import axios from "axios";
import bdjs from "@bd-core/bdjs";
import CONFIG from "@bd-core/config";

const bdapi = axios.create({
  baseURL: CONFIG.restURL,
});

// Uncomment code below and if your application using token
// bdapi.defaults.headers.common['Authorization'] = AUTH_TOKEN;
//

// used only for blindspot
bdapi.interceptors.request.use(
  function (config) {
    // Do something before request is sent
    const getParentOrigin = () => {
      const locationAreDisctint = window.location !== window.parent.location;
      const parentOrigin = (
        (locationAreDisctint ? document.referrer : document.location) || ""
      ).toString();

      if (parentOrigin) {
        return new URL(parentOrigin).origin;
      }

      const currentLocation = document.location;

      if (
        currentLocation.ancestorOrigins &&
        currentLocation.ancestorOrigins.length
      ) {
        return currentLocation.ancestorOrigins[0];
      }

      return "";
    };

    const urlSearchParams = new URLSearchParams(window.location.search);
    // @ts-ignore
    const params = Object.fromEntries(urlSearchParams.entries());
    if (params["bd-token"] && getParentOrigin()) {
      const parsedQuery = bdjs.getAllQueryString(window.location.search);

      const query = {
        ...parsedQuery,
        "bd-origin": getParentOrigin(),
      };

      config.url += "?" + bdjs.objectToQuerystring(query);
    }

    return config;
  },
  function (error) {
    // Do something with request error
    return Promise.reject(error);
  }
);

export default bdapi;
